<template>
  <Container isSmallerGap>
    <template #header>
      <div class="transaction-detail-accordion_header">
        <BaseSkeleton class="w-[200px] h-[20px] rounded-md" />
        <span class="arrow">
          <BaseSvgIcon
            name="arrow-simple"
            class="transaction-detail-accordion_arrow-icon"
          />
        </span>
      </div>
    </template>
    <template #body>
      <BaseAccordionBody class="accordion" :show="true" :transition="150">
        <div class="transaction-detail-accordion_body">
          <div class="transaction-detail-accordion_body_main">
            <div
              class="transaction-detail-accordion_body_item"
              v-for="index in 6"
              :key="index"
            >
              <BaseSkeleton class="w-[80px] h-[16px] rounded-md" />
              <div class="transaction-detail-accordion_body_item_value">
                <div
                  class="transaction-detail-accordion_body_item_value_titles"
                >
                  <BaseSkeleton
                    class="w-[120px] h-[16px] rounded-md mb-[2px]"
                  />
                  <BaseSkeleton class="w-[100px] h-[16px] rounded-md" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </BaseAccordionBody>
    </template>
  </Container>
</template>

<script>
import { BaseSvgIcon, BaseAccordionBody, Container } from "@/shared/ui";
import BaseSkeleton from "@/shared/ui/BaseSkeleton/BaseSkeleton.vue";
import "@/assets/icons/SVG/arrow-simple.svg";

export default {
  name: "TransactionDetailSkeleton",
  components: {
    BaseSkeleton,
    BaseSvgIcon,
    BaseAccordionBody,
    Container,
  },
};
</script>

<style lang="scss" scoped>
:deep(.container_body) {
  border: none;
}

.transaction-detail-accordion {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--Dark-850, #1a1a1a);
  background: var(--Dark-900, #111);
  padding: 32px;

  &_body {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;

    &_main {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto;
      width: 100%;
      grid-column-gap: 32px;

      @media (width < 1024px) {
        grid-template-columns: 1fr;
      }
    }

    &_item {
      display: grid;
      grid-template-columns: 1fr 1.5fr;
      border-bottom: 1px solid #1a1a1a;
      padding: 16px 0;

      &:nth-last-child(-n + 2) {
        border-bottom: none;
      }

      &_value {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 6px;

        &_titles {
          display: flex;
          flex-direction: column;
          gap: 2px;

          .accordion-link {
            font-size: 14px;
            font-weight: 500;
            line-height: 1.35;
            //color: var(--Link-Color, #8f42ff);
            text-decoration: none;
            cursor: pointer;

            &:hover {
              text-decoration: underline;
            }
          }
        }

        .copy {
          min-width: 16px;
          min-height: 16px;
          transition: color 0.3s;
          cursor: pointer;
          color: #c18afd;

          &:hover {
            color: #fff;
          }
        }
      }
    }
  }

  &_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    width: 100%;
  }

  &_arrow-icon {
    width: 24px;
    height: 24px;
  }
}

.arrow {
  transition: transform 0.3s ease;
  margin-left: 16px;
}

.open {
  transform: rotate(180deg);
}

.container {
  :deep(.e-accordion-body) {
    display: flex;
    width: 100%;

    .e-accordion-body__body {
      display: flex;
      width: 100%;
    }
  }
}

.confirmed-text {
  color: #43a047 !important;
  line-height: 150% !important;
}

.unconfirmed-text {
  color: #e53935 !important;
  line-height: 150% !important;
}

.blocks-text {
  line-height: 150% !important;
}
</style>
